import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Popup from '../../../common/Popup';
import DocketDetailsPurchaseForm from './DocketDetailsPurchaseForm';
import { buyAllParts, downloadPdfCombinedZipped } from '../../../../redux/actions/docketActions';
import { hasValidClientCode } from '../../../../redux/actions/clientCodeAction';

export class DownloadZipWithSubpartsPopup extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
      this.downloadPdfCombinedZipped();
    }
  }

  buy = () => {
    if (this.props.dispatch(hasValidClientCode())) {
      this.props.dispatch(buyAllParts(this.props.popup.data)).then(() => this.downloadPdfCombinedZipped());
    } else {
      this.props.onClose();
    }
  };

  downloadPdfCombinedZipped = () => {
    this.props.dispatch(downloadPdfCombinedZipped(this.props.popup.data));
  };

  render() {
    const { popup, onClose, docketParts } = this.props;

    return (
      <Popup
        show={popup.show}
        clsName="docket-pdf-zip-popup"
        topBarTitle="Download Combined PDFs in a Zip File"
        onClose={onClose}
      >
        <DocketDetailsPurchaseForm showXfaWarning docketParts={docketParts} buy={this.buy} />
      </Popup>
    );
  }
}

DownloadZipWithSubpartsPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  docketParts: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  const { popup, docketParts, favoriteEmail } = state.get('dockets').toJS();

  return {
    popup,
    docketParts,
    favoriteEmail,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadZipWithSubpartsPopup);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/DownloadZipWithSubpartsPopup.jsx